$(document).ready(function() {
	if($.cookie('section_cookie') != 'set'){
		$('#modalCookie').modal('show');
	} 
	$('body').on('click', '.accept_cookies', function(){
		$.cookie('section_cookie', 'set');
	});
});